// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowsePharmaciesLink_wrapper___gFIV","iconStack":"BrowsePharmaciesLink_iconStack__dUAM4","icon":"BrowsePharmaciesLink_icon__uwoby"};